import { themedUseStyletron } from '../../../theme/customTheme'
import { MdOutlineSensorDoor } from "react-icons/md";
import { IDoor } from './types'

export function SmallPanel(props: IDoor) {
    const [, theme] = themedUseStyletron();

    return (

                 <MdOutlineSensorDoor color={props.isOpen ? theme.colors.negative500 : theme.colors.contentTertiary} size='60px' />
    );
}